<template>
  <section>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Edit Document Name</p>
      </header>
      <section class="modal-card-body">
        <input
          @focus="$event.target.select()"
          class="input"
          type="text"
          maxlength="256"
          v-model="document.name"
          placeholder="Document name"
          required
          v-focus
          @keyup.enter="() => { saveDocumentName(); $parent.close() }"
        />
      </section>
      <footer class="modal-card-foot">
        <button
          class="button"
          type="button"
          @click="() => { cancelDocument(); $parent.close() }"
        >Cancel</button>
        <button
          class="button is-primary"
          @click="() => { saveDocumentName(); $parent.close() }"
        >Save</button>
      </footer>
    </div>
  </section>
</template>

<script>
import store from "@/store";
import Helpers from "@/services/Helpers.js";

export default {
  components: {
    Helpers
  },
  props: {
    document: "",
    propertyId: String
  },
  data() {
    return {
      stages: Helpers.getStages(),
      originalDocumentName: ""
    };
  },
  methods: {
    saveDocumentName() {
      var propertyId = this.propertyId;
      var documentId = this.document.id;
      var documentName = this.document.name;
      store.dispatch("updateDocumentName", {
        propertyId,
        documentId,
        documentName
      });
    },
    cancelDocument() {
      this.document.name = this.originalDocumentName;
    }
  },
  mounted() {
    this.originalDocumentName = this.document.name;
  }
};
</script>

<style>
</style>
